import React from "react";
import { motion } from "framer-motion";

export const Services = (props) => {
  return (
    <motion.section
      id="services"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.4 }}
    >
      <div className="container">
        <div className="section-header-modern">
          <span className="section-tag"><i className="fa fa-cubes"></i> Our Services</span>
          <h2>What We Offer</h2>
          <p>End-to-end logistics coverage — from sea and air freight to customs clearance, cargo handling, and last-mile delivery.</p>
        </div>
        <div className="services-card-grid">
          {props.data
            ? props.data.map((d, i) => (
                <motion.div
                  key={`${d.name}-${i}`}
                  className="svc-card"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.35, delay: i * 0.06 }}
                >
                  <div className="svc-card-icon">
                    <i className={d.icon}></i>
                  </div>
                  <div className="svc-card-body">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </motion.div>
              ))
            : "loading"}
        </div>
      </div>
    </motion.section>
  );
};
